export default __webpack_public_path__ + "static/media/noxtide.4a73381b.png";